<template>
  <div
    class="bg-black-transparent absolute w-full h-full backdrop-filter backdrop-blur-sm top-0 left-0 flex items-center justify-center">
    <div
      class="popup h-auto 1.5xl:w-7/10 1.8xl:w-6/10 fhd:w-5/10 p-4 mx-auto bg-white items-center classen__rounded relative">
      <div class="flex flex-col mb-7">
        <button class="self-end pr-5" @click="$emit('cancel')"><i class="fas fa-times text-3xl"></i>
        </button>
        <p class="self-center text-2xl font-bold mb-2">{{ getTranslation('generateExcel') }}</p>
      </div>
      <div class="flex flex-col">
        <div class="w-7/10 self-center">
          <p>{{ getTranslation('currentSelection') }}: {{ selection.name }}</p>
          <p class="pt-5 pb-2 font-extrabold">{{ getTranslation('information') }}:</p>
          <div class="flex pb-2" @click="selectAllOptions()">
            <c-checkbox :selected="selectAll" :mode="'medium'"/>
            <label>{{ getTranslation('selectAll') }}</label>
          </div>
          <div class="grid grid-rows-11 grid-flow-col gap-4 ml-2">
            <div class="flex"
                 v-for="information in informationOptions"
                 @click="selectOption(information)">
              <c-checkbox :selected="information.selected"/>
              <label :class="{'requiredOption':information.disabled}">{{
                  information.value
                }}</label>
            </div>
          </div>
          <div class="flex flex-col">
            <button @click="generateExcel"
                    class="classen__button leading-none hover__button addButtonSendInvite mb-5 px-3 self-center generateExcelButton px-5 mt-12 self-center">
              <p>{{ getTranslation('generateExcel') }}</p>
            </button>
          </div>
        </div>
      </div>
    </div>
    <c-loader v-if="isLoaderVisible"/>
  </div>
</template>

<script>
import getTranslation from "../../../mixins/getTranslation";
import download from "../../../mixins/download";
import CustomCheckbox from "../../form/CustomCheckbox";
import Loader from "../../Loader";

export default {
  name: "GenerateExcelPopup",

  mixins: [getTranslation, download],

  props: {
    selection: {required: true, default: ''},
    selectedOptions: {required: false, default: null}
  },

  components: {
    'c-checkbox': CustomCheckbox,
    'c-loader': Loader,
  },

  data() {
    return {
      isLoaderVisible: true,
      selectAll: false,
      informationOptions: [],
      interval: null
    }
  },

  created() {
    this.setInformationOptions()
  },

  destroyed() {
      clearInterval(this.interval)
  },

  methods: {
    setInformationOptions() {
      let informationOptions = [
        {
          key: 'articleNumber',
          value: this.getTranslation('articleNumber'),
          selected: true,
          disabled: true
        },
        {
          key: 'articleName',
          value: this.getTranslation('articleName'),
          selected: true,
          disabled: true
        },
        {key: 'range', value: this.getTranslation('range'), selected: false},
        {key: 'category', value: this.getTranslation('category'), selected: false},
        {key: 'branding', value: this.getTranslation('collection'), selected: false},
        {key: 'productgroup', value: this.getTranslation('productGroup'), selected: false},
        {key: 'dimensions', value: this.getTranslation('dimensions'), selected: false},
        {key: 'structure', value: this.getTranslation('structure'), selected: false},
        {key: 'lockingSystem', value: this.getTranslation('lockingSystem'), selected: false},
        {key: 'vGroove', value: this.getTranslation('bevel'), selected: false},
        {key: 'bevelColor', value: this.getTranslation('bevelColor'), selected: false},
        {key: 'classification', value: this.getTranslation('acClassification'), selected: false},
        {key: 'wearclass', value: this.getTranslation('wearClass'), selected: false},
        {key: 'decorName', value: this.getTranslation('decor'), selected: false},
        {key: 'decorColor', value: this.getTranslation('decorColor'), selected: false},
        {key: 'decorMaterial', value: this.getTranslation('decorMaterial'), selected: false},
        {key: 'planksPerBox', value: this.getTranslation('planksPerBox'), selected: false},
        {key: 'sqmPerBox', value: this.getTranslation('areaPerBox'), selected: false},
        {key: 'weightPerBox', value: this.getTranslation('weightPerBox'), selected: false},
        {key: 'boxesPerPallet', value: this.getTranslation('boxesPerPallet'), selected: false},
        {key: 'sqmPerPallet', value: this.getTranslation('areaPerPallet'), selected: false},
        {key: 'weightPerPallet', value: this.getTranslation('weightPerPallet'), selected: false},
        {key: 'grossweightPerSqm', value: this.getTranslation('grossWeightOfSqm'), selected: false},
        {key: 'eanCode', value: this.getTranslation('eanCode'), selected: false},
        {key: 'certification', value: this.getTranslation('certification'), selected: false},
        {
          key: 'environmentalLabel',
          value: this.getTranslation('environmentalLabel'),
          selected: false
        },
        {key: 'guaranty', value: this.getTranslation('guaranty'), selected: false},
        {key: 'box', value: this.getTranslation('box'), selected: false},
        {key: 'inlay', value: this.getTranslation('inlay'), selected: false},
        {key: 'phaseOut', value: this.getTranslation('phaseOut'), selected: false}
      ];

      if (this.selectedOptions) {
        informationOptions = informationOptions.filter((option) => {
          return this.selectedOptions.includes(option.key);
        });
      }
      this.informationOptions = informationOptions;
      this.isLoaderVisible = false;
    },

    selectOption(information) {
      if (information.disabled) {
        return;
      }
      this.$set(information, 'selected', !information.selected);
      this.selectAll = !this.informationOptions.some((option) => option.selected === false);
    },

    selectAllOptions() {
      this.selectAll = !this.selectAll;
      this.informationOptions.forEach((option) => {
        if (option.disabled) {
          return;
        }
        option.selected = this.selectAll;
      });
    },

    generateExcel() {
      this.isLoaderVisible = true;
      let informationOptions = this.informationOptions.filter((info) => info.selected === true).map((info) => info.key);
      let data = {
        selectionId: this.selection.id,
        selectionName: this.selection.name,
        selectionImage: this.selection.logo,
        informationOptions: informationOptions
      };

      this.$dashboardStore.dispatch('generateExcel', data)
        .then((res) => {
            let statusId = res.statusId
            this.interval = setInterval(() => {
                this.$dashboardStore.dispatch('getGenerateExcelStatus', {
                    selectionId: this.selection.id,
                    statusId: statusId
                }).then((status) => {
                    if (status.status === 'finished') {
                        clearInterval(this.interval);
                        this.downloadFile(status.data.url)
                        this.isLoaderVisible = false;
                    }

                    if (status.status === 'failed') {
                        clearInterval(this.interval);
                        console.error('Something went wrong')
                        this.isLoaderVisible = false;
                    }
                })
            }, 5000)
        })
        .catch((e) => {
          console.warn('Something went wrong', e)
          this.isLoaderVisible = false;
        });
    },
  }
}
</script>

<style scoped>
.generateExcelButton {
  height: 42px;
  width: 160px;
}

.requiredOption:after {
  content: ' *';
  color: #E92323;
}
</style>
